import React from 'react';

const Balance = (props) => {
    const { msg, sendNewMsg } = props;
    
    // ✅ Handle both array and object cases
    const balanceData = Array.isArray(msg) ? msg[0] : msg;
    if (!balanceData || balanceData.parentId !== 1 || balanceData.balance==null) {
        return null;
    }
    
    const handleRechargeClick = () => {
        if (balanceData.buttonDeepLink) {
            window.open(balanceData.buttonDeepLink,'_blank');
        }
    };
    
    return (
        <div className="balance-card">
            <div className="cardheader">
                <span className="lbl">{balanceData.title}</span>
                {balanceData.buttonText && (
                    <button className="recharge-btn" onClick={handleRechargeClick}>
                        {balanceData.buttonText}
                    </button>
                )}
            </div>
            
            {balanceData.balance && (
                <div className="cardbody">
                    <span className="balance-amount">{balanceData.balance.split(' ')[0]} </span>
                    <span className="currency">{balanceData.balance.split(' ')[1]}</span>
                </div>
            )}
            
            <div className="cardfooter">
                <span className="validity-icon"><i className="fa fa-calendar"></i></span>
                <span className="validity-text">{balanceData.date}</span>
            </div>
        </div>
    );
};

export default Balance;